/**
 * Every RTK Query tag type, declared once (v2 kept these in queryKeys.ts).
 * Tag ids are prefixed with the source so /test and / invalidate independently.
 */
import type { SourceId } from '@/data-sources/contract';

export const TAG_TYPES = [
  'Bootstrap',
  'Credits',
  'Widget',
  'Conversation',
  'Report',
  'Chat',
  'QuickSearch',
  'Settings',
  'Team',
  'Influencer',
] as const;

export type TagType = (typeof TAG_TYPES)[number];

export const tag = <T extends TagType>(
  type: T,
  source: SourceId,
  id: string | number = 'LIST',
) => ({
  type,
  id: `${source}:${id}`,
});
